import { cloneElement, type ReactNode } from 'react';

import type * as api from '@gitbook/api-client';
import { assertNever } from '@gitbook/util-ts';

import { SiteExternalLinkIcon } from '../SiteExternalLinkIcon';
import { SiteSectionGroupIcon } from '../SiteSectionGroupIcon';
import { SiteSectionIcon } from '../SiteSectionIcon';
import { SiteVariantIcon } from '../SiteVariantIcon';

export function SiteStructureItemList(props: {
    items: (api.SiteSectionGroup | api.SiteSection | api.SiteSpace | api.SiteExternalLink)[];
    description?: ReactNode;
}) {
    const { items, description } = props;
    return (
        <div className="flex flex-col gap-2">
            {description ? <p>{description}</p> : null}
            <ul className="flex flex-col gap-2">
                {items.map((item) => {
                    const icon = (() => {
                        switch (item.object) {
                            case 'site-section-group':
                                return <SiteSectionGroupIcon siteSectionGroup={item} />;
                            case 'site-section':
                                return <SiteSectionIcon siteSection={item} />;
                            case 'site-space':
                                return <SiteVariantIcon />;
                            case 'site-external-link':
                                return <SiteExternalLinkIcon siteExternalLink={item} />;
                            default:
                                assertNever(item);
                        }
                    })();
                    return (
                        <li
                            key={item.id}
                            className="flex items-center gap-2 rounded-sm border px-3 py-2"
                        >
                            {cloneElement(icon, { className: 'size-4 shrink-0 text-muted' })}
                            <span className="truncate">{item.title}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}
